import React, { PureComponent } from 'react';
import io from 'socket.io-client';
import API_HOST from '../../shared/utils/ApiHost.js';
// import { connect, getData, playerDrafted } from '../../shared/utils/socket.js';
import { store } from "../App/store";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import DraftOrder from './components/DraftOrder';
import Available from './components/Available';
import MyTeam from './components/MyTeam';
import OtherTeams from './components/OtherTeams';
import StatsTable from './components/StatsTable';

class DraftPage extends PureComponent {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    static contextType = store;
    
    constructor(props){
        super(props);
        this.state = {
            // room: this.props.cookies.get("room") || "",
            // draft_order: [],
            // prev_pick: '',
            // current_pick: '',
            // last_action: '',
            // users: [],
            // players: [],
            // me: localStorage.getItem('username') !== null ? localStorage.getItem('username') : '',
            // myTeam: localStorage.getItem('teamId') !== null ? Number(localStorage.getItem('teamId')) : '',
            // isAdmin: localStorage.getItem('admin') !== null && localStorage.getItem('admin') === 'true',
            // isMyTurn: false,
            showTable: false
        }

        this.socket = io(API_HOST,{
            withCredentials: true,
            extraHeaders: {
                "room": localStorage.getItem('room') !== null ? localStorage.getItem('room') : 'urb_2002'
            }
        });
    }

    componentDidMount = () => {
        const globalState = this.context;
        const { myTeam } = globalState.state;
        const { dispatch } = this.context;

        this.socket.emit('join','urb_2002')
        // this.socket.on("connected", data => {
        //     console.log(data)
        //     this.setState({room:data.room});
        //     this.socket.emit('update','now')
        // });

        this.socket.on("update_order", data => {
            console.log(data)
            console.log('new order: ' + data.newDraftOrder);
            // this.setState({
            //     draft_order: data.newDraftOrder,
            //     players: data.players
            // });

            dispatch({type:'SET_DRAFT_ORDER',data})

        });

        this.socket.on('get_data', data => {
            console.log('get original data')
            console.log(data)
            // var users = data.users;
            // // set the upcoming picks
            // var allPlayers = data.players;
            var prevPick = data.players.filter(x => x.team !== 0).length;
            var currentPick = data.players.filter(x => x.team !== 0).length + 1;
            var myTeam = localStorage.getItem('teamId') !== null ? Number(localStorage.getItem('teamId')) : '';

            var isMyTurn = data.draft_order.some(pick => pick.position === currentPick && pick.team === myTeam);

            // this.setState({
            //     draft_order: data.draft_order,
            //     last_action: data.last_action,
            //     prev_pick: prevPick,
            //     current_pick: currentPick,
            //     players: allPlayers,
            //     users: users,
            //     me: localStorage.getItem('username') !== null ? localStorage.getItem('username') : '',
            //     myTeam: myTeam,
            //     isAdmin: localStorage.getItem('admin') !== null && localStorage.getItem('admin') === 'true',
            //     isMyTurn: isMyTurn
            // })
            console.log(data)
            dispatch({type:'SET_DB',value:data})
            dispatch({type:'SET_PREV_PICK',value:prevPick})
            dispatch({type:'SET_CURRENT_PICK',value:currentPick})
            dispatch({type:'SET_MY_TURN',value:isMyTurn})
        })

        this.socket.on('player_drafted', data => {
            console.log('player drafted frontend')
            console.log(data)
            // set the upcoming picks

            var prevPick = data.players.filter(x => x.team !== 0).length;
            var currentPick = data.players.filter(x => x.team !== 0).length + 1;

            var isMyTurn = data.draft_order.some(pick => pick.position === currentPick && pick.team === myTeam);

            // this.setState({
            //     draft_order: data.draft_order,
            //     last_action: data.last_action,
            //     current_pick: currentPick,
            //     players: allPlayers,
            //     isMyTurn: isMyTurn
            // })

            dispatch({type:'SET_DB',value:data})
            dispatch({type:'SET_PREV_PICK',value:prevPick})
            dispatch({type:'SET_CURRENT_PICK',value:currentPick})
            dispatch({type:'SET_MY_TURN',value:isMyTurn})

        })

        // this.socket.on("player_returned", data => {
        //     console.log('player returned frontend')
        //     console.log(data)
        //     // this.setState({
        //     //     player_returned: true
        //     // });
        // });

        
    
    }

    togglePopup = () => {
        this.setState({
            showTable: !this.state.showTable
        })
    }

    setDraftOrder = () => {
        // const socket = io(API_HOST,{
        //     withCredentials: true,
        //     extraHeaders: {
        //         "room": localStorage.getItem('room') !== null ? localStorage.getItem('room') : 'urb_2002'
        //     }
        // });
        this.socket.emit('set_order')

    }
    // javascript:location.reload(true)

    render() {
        const globalState = this.context;
        const { me, myTeam, users, players, draft_order, current_pick, prev_pick, last_action, isAdmin, isMyTurn } = globalState.state;
        const { showTable } = this.state;
        var tableClass = showTable ? 'show-table' : '';
        document.body.classList.add('draftroom-body')
        let year = (new Date()).getFullYear();
        if(isAdmin) { 
            document.body.classList.add('admin')
        } else {
            document.body.classList.add('non-admin')
        }
        return (
            <div id="draft-room-wrapper" className="draftroom">
                <header>
                    <div id="logo"><img src="//mintconditioned.com/mintmadnessdraft/images/mint-madness-logo.svg" alt="Mint Madness" height="90" width="480" /></div>
                    <h1>{year} Draft</h1>
                    <nav>
                        <ul>
                            {isAdmin && 
                                <li><span className="draft-menuitem" onClick={() => this.setDraftOrder()}>Reset Order</span></li>
                            }
                            <li><a href="/standings">Standings</a></li>
                            <li><span className="draft-menuitem" onClick={() => this.togglePopup()}>Player Stats</span></li>
                            <li><a href="//mintconditioned.com/mintmadness" target="_blank" rel="noopener noreferrer">Past Results</a></li>
                            {/* <li><a href="/#" className="refreshbutton">Refresh</a></li> */}
                        </ul>
                    </nav>
                </header>
                <div id="main-content">
                    <DraftOrder draftorder={draft_order} players={players} lastAction={last_action} prevPick={prev_pick} currentPick={current_pick} showTable={showTable}/>
                    <div id="draft-room">
                        <div id="draft-left">
                            <div className="team-none">
                                <div className="team-interior">
                                    <h3 className="team-header">Available</h3>
                                    <Available myTurn={isMyTurn} players={players} isAdmin={isAdmin} currentPick={current_pick} isMyTurn={isMyTurn} />
                                </div>
                            </div>
                        </div>
                        <div id="draft-right">
                            <MyTeam me={me} myTeam={myTeam} users={users} players={players} currentPick={current_pick} isAdmin={isAdmin} isMyTurn={isMyTurn}/>
                            <OtherTeams myTeam={myTeam} users={users} currentPick={current_pick} players={players} isAdmin={isAdmin} isMyTurn={isMyTurn}/>
                        </div>
                    </div>
                </div>
                <div id="stats-popup" className={tableClass}>
                    <div id="stats-popup-close-btn" onClick={() => this.togglePopup()}>Close X</div>
                    <div id="stats-popup-inner">
                        <StatsTable players={players} />
                    </div>
                </div>
                <p style={{position: 'fixed', bottom: '-18px', left: '3px', opacity: '0.2'}}>{prev_pick}</p>
            </div>
            
            )
    }
    
};

export default withCookies(DraftPage);
